import { EventEmitter, SimpleChanges } from "@angular/core";
import { ZoomService } from '../zoom.service';
import { Session } from '../../../shared/model/session.model';
import { AccountService } from '../../../core/auth/account.service';
import { SessionStatusManagerService } from '../../../core/session/session-status-manager.service';
import { BaseComponent } from '../../../shared/base.component';
import { SessionStorageService } from "ngx-webstorage";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { DeviceAccessDeniedNotificationComponent } from '../device-access-denied-notification/device-access-denied-notification.component';
import { UserService } from '../../../core/user/user.service';
import { LANGUAGES } from '../../../app.constants';
import { SessionService } from '../../session/session.service';
import * as i0 from "@angular/core";
import * as i1 from "ngx-webstorage";
import * as i2 from "@ng-bootstrap/ng-bootstrap";
import * as i3 from "../../../core/auth/account.service";
import * as i4 from "../zoom.service";
import * as i5 from "../../../core/session/session-status-manager.service";
import * as i6 from "../../../core/user/user.service";
import * as i7 from "../../session/session.service";
import * as i8 from "@angular/common";
import * as i9 from "../../../ng-jhipster/language/jhi-translate.directive";
import * as i10 from "@angular/material/form-field";
import * as i11 from "@angular/material/select";
import * as i12 from "@angular/forms";
import * as i13 from "../camera-preview/camera-preview.component";
import * as i14 from "@angular/material/core";
import * as i15 from "../audio-preview/audio-preview.component";
import * as i16 from "@angular/material/tooltip";
import * as i17 from "@fortawesome/angular-fontawesome";
import * as i18 from "@ctrl/ngx-emoji-mart/ngx-emoji";
import * as i19 from "@ngx-translate/core";
import * as i20 from "../../../shared/language/find-flag-code-from-key.pipe";
function JoinVideoCallComponent_div_0_camera_preview_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "camera-preview", 19);
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r2 = i0.ɵɵreference(1);
    const _r4 = i0.ɵɵreference(4);
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("session", ctx_r3.session)("deviceId", ctx_r3.selectedCamera == null ? null : ctx_r3.selectedCamera.deviceId)("width", _r2.offsetWidth - 500)("height", _r4.offsetHeight);
} }
function JoinVideoCallComponent_div_0_div_5_mat_option_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 21);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const speaker_r13 = ctx.$implicit;
    i0.ɵɵproperty("value", speaker_r13);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(speaker_r13.label);
} }
function JoinVideoCallComponent_div_0_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "h4", 20);
    i0.ɵɵelementStart(2, "mat-form-field", 9);
    i0.ɵɵelementStart(3, "mat-select", 10);
    i0.ɵɵlistener("ngModelChange", function JoinVideoCallComponent_div_0_div_5_Template_mat_select_ngModelChange_3_listener($event) { i0.ɵɵrestoreView(_r15); const ctx_r14 = i0.ɵɵnextContext(2); return ctx_r14.selectedSpeaker = $event; })("selectionChange", function JoinVideoCallComponent_div_0_div_5_Template_mat_select_selectionChange_3_listener($event) { i0.ɵɵrestoreView(_r15); const ctx_r16 = i0.ɵɵnextContext(2); return ctx_r16.switchSpeaker($event.value); });
    i0.ɵɵtemplate(4, JoinVideoCallComponent_div_0_div_5_mat_option_4_Template, 2, 2, "mat-option", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngModel", ctx_r5.selectedSpeaker)("disabled", !(ctx_r5.speakerList == null ? null : ctx_r5.speakerList.length));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r5.speakerList);
} }
function JoinVideoCallComponent_div_0_mat_option_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 21);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const camera_r17 = ctx.$implicit;
    i0.ɵɵproperty("value", camera_r17);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(camera_r17.label);
} }
function JoinVideoCallComponent_div_0_mat_option_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 21);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const microphone_r18 = ctx.$implicit;
    i0.ɵɵproperty("value", microphone_r18);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(microphone_r18.label);
} }
function JoinVideoCallComponent_div_0_audio_preview_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "audio-preview", 22);
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("deviceId", ctx_r8.selectedMicrophone == null ? null : ctx_r8.selectedMicrophone.deviceId);
} }
function JoinVideoCallComponent_div_0_div_18_mat_option_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 21);
    i0.ɵɵelement(1, "ngx-emoji", 28);
    i0.ɵɵpipe(2, "findFlagCodeFromKey");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const language_r20 = ctx.$implicit;
    i0.ɵɵproperty("value", language_r20);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("emoji", "flag-", i0.ɵɵpipeBind1(2, 3, language_r20.code), "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", language_r20.name, " ");
} }
function JoinVideoCallComponent_div_0_div_18_Template(rf, ctx) { if (rf & 1) {
    const _r22 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵelement(1, "h4", 24);
    i0.ɵɵelementStart(2, "span", 25);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelement(4, "fa-icon", 26);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "mat-form-field", 9);
    i0.ɵɵelementStart(6, "mat-select", 27);
    i0.ɵɵlistener("ngModelChange", function JoinVideoCallComponent_div_0_div_18_Template_mat_select_ngModelChange_6_listener($event) { i0.ɵɵrestoreView(_r22); const ctx_r21 = i0.ɵɵnextContext(2); return ctx_r21.selectedLanguage = $event; })("selectionChange", function JoinVideoCallComponent_div_0_div_18_Template_mat_select_selectionChange_6_listener() { i0.ɵɵrestoreView(_r22); const ctx_r23 = i0.ɵɵnextContext(2); return ctx_r23.languageChanged(); });
    i0.ɵɵtemplate(7, JoinVideoCallComponent_div_0_div_18_mat_option_7_Template, 4, 5, "mat-option", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("matTooltipPosition", "below")("matTooltip", i0.ɵɵpipeBind1(3, 4, "sessionChat.coachSessionControl.coachTranscriptionTooltip"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngModel", ctx_r9.selectedLanguage);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r9.languageList);
} }
function JoinVideoCallComponent_div_0_div_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵelement(1, "h4", 24);
    i0.ɵɵelementStart(2, "span", 25);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelement(4, "fa-icon", 26);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div");
    i0.ɵɵelement(6, "ngx-emoji", 28);
    i0.ɵɵpipe(7, "findFlagCodeFromKey");
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("matTooltipPosition", "below")("matTooltip", i0.ɵɵpipeBind1(3, 4, "sessionChat.userSessionControl.userTranscriptionTooltip"));
    i0.ɵɵadvance(4);
    i0.ɵɵpropertyInterpolate1("emoji", "flag-", i0.ɵɵpipeBind1(7, 6, ctx_r10.selectedLanguage == null ? null : ctx_r10.selectedLanguage.code), "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r10.selectedLanguage == null ? null : ctx_r10.selectedLanguage.name, " ");
} }
function JoinVideoCallComponent_div_0_button_24_Template(rf, ctx) { if (rf & 1) {
    const _r25 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 29);
    i0.ɵɵlistener("click", function JoinVideoCallComponent_div_0_button_24_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r25); const ctx_r24 = i0.ɵɵnextContext(2); return ctx_r24.joinCall(); });
    i0.ɵɵelement(1, "span", 30);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("disabled", !ctx_r11.selectedMicrophone && !ctx_r11.selectedCamera);
} }
function JoinVideoCallComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r27 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2, 3);
    i0.ɵɵtemplate(2, JoinVideoCallComponent_div_0_camera_preview_2_Template, 1, 4, "camera-preview", 4);
    i0.ɵɵelementStart(3, "div", 5, 6);
    i0.ɵɵtemplate(5, JoinVideoCallComponent_div_0_div_5_Template, 5, 3, "div", 7);
    i0.ɵɵelementStart(6, "div");
    i0.ɵɵelement(7, "h4", 8);
    i0.ɵɵelementStart(8, "mat-form-field", 9);
    i0.ɵɵelementStart(9, "mat-select", 10);
    i0.ɵɵlistener("ngModelChange", function JoinVideoCallComponent_div_0_Template_mat_select_ngModelChange_9_listener($event) { i0.ɵɵrestoreView(_r27); const ctx_r26 = i0.ɵɵnextContext(); return ctx_r26.selectedCamera = $event; })("selectionChange", function JoinVideoCallComponent_div_0_Template_mat_select_selectionChange_9_listener($event) { i0.ɵɵrestoreView(_r27); const ctx_r28 = i0.ɵɵnextContext(); return ctx_r28.switchCamera($event.value); });
    i0.ɵɵtemplate(10, JoinVideoCallComponent_div_0_mat_option_10_Template, 2, 2, "mat-option", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div");
    i0.ɵɵelement(12, "h4", 12);
    i0.ɵɵelementStart(13, "mat-form-field", 9);
    i0.ɵɵelementStart(14, "mat-select", 10);
    i0.ɵɵlistener("ngModelChange", function JoinVideoCallComponent_div_0_Template_mat_select_ngModelChange_14_listener($event) { i0.ɵɵrestoreView(_r27); const ctx_r29 = i0.ɵɵnextContext(); return ctx_r29.selectedMicrophone = $event; })("selectionChange", function JoinVideoCallComponent_div_0_Template_mat_select_selectionChange_14_listener($event) { i0.ɵɵrestoreView(_r27); const ctx_r30 = i0.ɵɵnextContext(); return ctx_r30.switchMic($event.value); });
    i0.ɵɵtemplate(15, JoinVideoCallComponent_div_0_mat_option_15_Template, 2, 2, "mat-option", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "div");
    i0.ɵɵtemplate(17, JoinVideoCallComponent_div_0_audio_preview_17_Template, 1, 1, "audio-preview", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(18, JoinVideoCallComponent_div_0_div_18_Template, 8, 6, "div", 14);
    i0.ɵɵtemplate(19, JoinVideoCallComponent_div_0_div_19_Template, 9, 8, "div", 14);
    i0.ɵɵelementStart(20, "div", 15);
    i0.ɵɵelementStart(21, "div");
    i0.ɵɵelementStart(22, "button", 16);
    i0.ɵɵlistener("click", function JoinVideoCallComponent_div_0_Template_button_click_22_listener() { i0.ɵɵrestoreView(_r27); const ctx_r31 = i0.ɵɵnextContext(); return ctx_r31.cancel(); });
    i0.ɵɵelement(23, "span", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(24, JoinVideoCallComponent_div_0_button_24_Template, 2, 1, "button", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.windowWidth > ctx_r0.screenThreshold);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r0.speakerList == null ? null : ctx_r0.speakerList.length);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngModel", ctx_r0.selectedCamera)("disabled", !(ctx_r0.cameraList == null ? null : ctx_r0.cameraList.length));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r0.cameraList);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngModel", ctx_r0.selectedMicrophone)("disabled", !(ctx_r0.microphoneList == null ? null : ctx_r0.microphoneList.length));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r0.microphoneList);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.windowWidth > ctx_r0.screenThreshold);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.isLanguageChangeable);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.isLanguageChangeable);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", ctx_r0.session != null);
} }
function JoinVideoCallComponent_div_1_camera_preview_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "camera-preview", 37);
} if (rf & 2) {
    const ctx_r32 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("isCameraOn", true)("session", ctx_r32.session)("deviceId", ctx_r32.selectedCamera == null ? null : ctx_r32.selectedCamera.deviceId);
} }
function JoinVideoCallComponent_div_1_audio_preview_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "audio-preview", 38);
} if (rf & 2) {
    const ctx_r33 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("deviceId", ctx_r33.selectedSpeaker == null ? null : ctx_r33.selectedSpeaker.deviceId);
} }
function JoinVideoCallComponent_div_1_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 39);
    i0.ɵɵelement(1, "h4", 24);
    i0.ɵɵelementStart(2, "span", 25);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelement(4, "fa-icon", 26);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div");
    i0.ɵɵelement(6, "ngx-emoji", 28);
    i0.ɵɵpipe(7, "findFlagCodeFromKey");
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r34 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("matTooltipPosition", "below")("matTooltip", i0.ɵɵpipeBind1(3, 4, "sessionChat.userSessionControl.userTranscriptionTooltip"));
    i0.ɵɵadvance(4);
    i0.ɵɵpropertyInterpolate1("emoji", "flag-", i0.ɵɵpipeBind1(7, 6, ctx_r34.selectedLanguage == null ? null : ctx_r34.selectedLanguage.code), "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r34.selectedLanguage == null ? null : ctx_r34.selectedLanguage.name, " ");
} }
function JoinVideoCallComponent_div_1_div_7_mat_option_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 21);
    i0.ɵɵelement(1, "ngx-emoji", 28);
    i0.ɵɵpipe(2, "findFlagCodeFromKey");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const language_r38 = ctx.$implicit;
    i0.ɵɵproperty("value", language_r38);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("emoji", "flag-", i0.ɵɵpipeBind1(2, 3, language_r38.code), "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", language_r38.name, " ");
} }
function JoinVideoCallComponent_div_1_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r40 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 39);
    i0.ɵɵelement(1, "h4", 24);
    i0.ɵɵelementStart(2, "span", 25);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelement(4, "fa-icon", 26);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "mat-form-field", 40);
    i0.ɵɵelementStart(6, "mat-select", 27);
    i0.ɵɵlistener("ngModelChange", function JoinVideoCallComponent_div_1_div_7_Template_mat_select_ngModelChange_6_listener($event) { i0.ɵɵrestoreView(_r40); const ctx_r39 = i0.ɵɵnextContext(2); return ctx_r39.selectedLanguage = $event; })("selectionChange", function JoinVideoCallComponent_div_1_div_7_Template_mat_select_selectionChange_6_listener() { i0.ɵɵrestoreView(_r40); const ctx_r41 = i0.ɵɵnextContext(2); return ctx_r41.languageChanged(); });
    i0.ɵɵtemplate(7, JoinVideoCallComponent_div_1_div_7_mat_option_7_Template, 4, 5, "mat-option", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r35 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("matTooltipPosition", "below")("matTooltip", i0.ɵɵpipeBind1(3, 4, "sessionChat.coachSessionControl.coachTranscriptionTooltip"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngModel", ctx_r35.selectedLanguage);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r35.languageList);
} }
function JoinVideoCallComponent_div_1_button_12_Template(rf, ctx) { if (rf & 1) {
    const _r43 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 29);
    i0.ɵɵlistener("click", function JoinVideoCallComponent_div_1_button_12_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r43); const ctx_r42 = i0.ɵɵnextContext(2); return ctx_r42.joinCall(); });
    i0.ɵɵelement(1, "span", 30);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r36 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("disabled", !ctx_r36.selectedMicrophone && !ctx_r36.selectedCamera);
} }
function JoinVideoCallComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r45 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 31);
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵtemplate(2, JoinVideoCallComponent_div_1_camera_preview_2_Template, 1, 3, "camera-preview", 32);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div");
    i0.ɵɵelement(4, "h4", 33);
    i0.ɵɵtemplate(5, JoinVideoCallComponent_div_1_audio_preview_5_Template, 1, 1, "audio-preview", 34);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, JoinVideoCallComponent_div_1_div_6_Template, 9, 8, "div", 35);
    i0.ɵɵtemplate(7, JoinVideoCallComponent_div_1_div_7_Template, 8, 6, "div", 35);
    i0.ɵɵelementStart(8, "div", 36);
    i0.ɵɵelementStart(9, "div");
    i0.ɵɵelementStart(10, "button", 16);
    i0.ɵɵlistener("click", function JoinVideoCallComponent_div_1_Template_button_click_10_listener() { i0.ɵɵrestoreView(_r45); const ctx_r44 = i0.ɵɵnextContext(); return ctx_r44.cancel(); });
    i0.ɵɵelement(11, "span", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(12, JoinVideoCallComponent_div_1_button_12_Template, 2, 1, "button", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.windowWidth < ctx_r1.screenThreshold);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r1.windowWidth < ctx_r1.screenThreshold);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r1.isLanguageChangeable);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.isLanguageChangeable);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", ctx_r1.session != null);
} }
export class JoinVideoCallComponent extends BaseComponent {
    constructor(sessionStorage, modalService, accountService, zoomService, sessionStatusManagerService, userService, sessionService) {
        super(sessionStorage, modalService);
        this.sessionStorage = sessionStorage;
        this.modalService = modalService;
        this.accountService = accountService;
        this.zoomService = zoomService;
        this.sessionStatusManagerService = sessionStatusManagerService;
        this.userService = userService;
        this.sessionService = sessionService;
        // @Output() onSpeakerChanged: EventEmitter<string> = new EventEmitter<string>();
        // @Output() onCameraChanged: EventEmitter<string> = new EventEmitter<string>();
        // @Output() onMicrophoneChanged: EventEmitter<string> = new EventEmitter<string>();
        this.onJoinCallClick = new EventEmitter();
        this.languageList = [
            { id: 40, code: "en", name: "English", nativeName: "English", coachReasoning: "" },
            { id: 39, code: "nl", name: "Dutch", nativeName: "Nederlands", coachReasoning: "" },
            { id: 51, code: "de", name: "German", nativeName: "Deutsch", coachReasoning: "" },
        ];
        this.screenThreshold = 1024;
        this.isCameraOn = true;
    }
    ngOnInit() {
        this.getAvailableSpeakersSubscription = this.zoomService.getAvailableSpeakers().subscribe(speakers => {
            this.speakerList = speakers;
            if (speakers === null || speakers === void 0 ? void 0 : speakers.length) {
                this.switchSpeaker(speakers[0]);
            }
        });
        this.getAvailableCamerasSubscription = this.zoomService.getAvailableCameras().subscribe(cameras => {
            this.cameraList = cameras;
            if (cameras === null || cameras === void 0 ? void 0 : cameras.length) {
                this.switchCamera(cameras[0]);
            }
        });
        this.getAvailableMicrophonesSubscription = this.zoomService.getAvailableMicrophones().subscribe(microphones => {
            this.microphoneList = microphones;
            if (microphones === null || microphones === void 0 ? void 0 : microphones.length) {
                this.switchMic(microphones[0]);
            }
        });
        this.zoomService.onDeviceAccessDenied$().subscribe(denied => {
            if (denied) {
                this.modalService.open(DeviceAccessDeniedNotificationComponent, { size: 'lg' });
            }
        });
        if (this.isLanguageChangeable) {
            this.userService.getCoachReasoningLanguages(this.session.coachId).subscribe(coachLanguages => {
                this.languageList = LANGUAGES.filter(lang => coachLanguages.includes(lang.code));
                this.setSelectedLanguageBasedOnSessionLanguage();
                if (this.selectedLanguage) {
                    this.languageChanged();
                }
            });
        }
        else {
            this.setSelectedLanguageBasedOnSessionLanguage();
        }
        // trying to pre init the Zoom client
        // this.zoomService.init().subscribe();
    }
    ngOnChanges(changes) {
        if (changes.session && !this.isLanguageChangeable) {
            this.setSelectedLanguageBasedOnSessionLanguage();
        }
    }
    setSelectedLanguageBasedOnSessionLanguage() {
        this.selectedLanguage = LANGUAGES.find(value => value.code === this.session.langKey);
    }
    switchSpeaker(speaker) {
        this.selectedSpeaker = speaker;
        this.zoomService.switchSpeaker(speaker);
    }
    switchCamera(camera) {
        this.selectedCamera = camera;
        this.zoomService.switchCamera(camera);
    }
    switchMic(mic) {
        this.selectedMicrophone = mic;
        this.zoomService.switchMic(mic);
    }
    languageChanged() {
        this.zoomService.switchLanguage(this.selectedLanguage.code);
    }
    cancel() {
        this.sessionStatusManagerService.navigateToSession(this.session, true);
    }
    joinCall() {
        var _a;
        if (!this.joinButtonClicked) {
            // prevent duplicate `onJoinCallClick` event emit
            this.joinButtonClicked = true;
            // if the language is changed by coach
            if (this.accountService.isCoach() && ((_a = this.selectedLanguage) === null || _a === void 0 ? void 0 : _a.code) !== this.session.langKey) {
                this.sessionService.changeSessionLanguage(this.selectedLanguage.code, this.session.id).subscribe(() => {
                    this.onJoinCallClick.emit();
                });
            }
            else {
                this.onJoinCallClick.emit();
            }
        }
    }
    ngOnDestroy() {
        var _a, _b, _c;
        super.ngOnDestroy();
        (_a = this.getAvailableMicrophonesSubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
        (_b = this.getAvailableSpeakersSubscription) === null || _b === void 0 ? void 0 : _b.unsubscribe();
        (_c = this.getAvailableCamerasSubscription) === null || _c === void 0 ? void 0 : _c.unsubscribe();
    }
}
JoinVideoCallComponent.ɵfac = function JoinVideoCallComponent_Factory(t) { return new (t || JoinVideoCallComponent)(i0.ɵɵdirectiveInject(i1.SessionStorageService), i0.ɵɵdirectiveInject(i2.NgbModal), i0.ɵɵdirectiveInject(i3.AccountService), i0.ɵɵdirectiveInject(i4.ZoomService), i0.ɵɵdirectiveInject(i5.SessionStatusManagerService), i0.ɵɵdirectiveInject(i6.UserService), i0.ɵɵdirectiveInject(i7.SessionService)); };
JoinVideoCallComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: JoinVideoCallComponent, selectors: [["join-video-call"]], inputs: { session: "session", isLanguageChangeable: "isLanguageChangeable", selectedLangKey: "selectedLangKey" }, outputs: { onJoinCallClick: "onJoinCallClick" }, features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature], decls: 2, vars: 2, consts: [["class", "join-video-call d-none d-flex justify-content-center p-2", 4, "ngIf"], ["class", "d-flex flex-column p-0 h-100 bg-white", 4, "ngIf"], [1, "join-video-call", "d-none", "d-flex", "justify-content-center", "p-2"], ["joinVideoCallContainer", ""], ["id", "camera-preview", 3, "session", "deviceId", "width", "height", 4, "ngIf"], ["id", "settings-card", 1, "card", "form-card", "d-flex", "flex-column"], ["settingContainer", ""], [4, "ngIf"], ["jhiTranslate", "sessionChat.coachSessionControl.selectCamera", 1, "item-bold"], ["appearance", "outline"], ["tabindex", "-1", 3, "ngModel", "disabled", "ngModelChange", "selectionChange"], [3, "value", 4, "ngFor", "ngForOf"], ["jhiTranslate", "sessionChat.coachSessionControl.selectMicrophone", 1, "item-bold"], [3, "deviceId", 4, "ngIf"], ["class", "mt-2", 4, "ngIf"], [1, "d-flex", "justify-content-end", "align-items-end", "m-2", "mt-4", "flex-grow-1"], [1, "btn", "btn-secondary", "m-2", 3, "click"], ["jhiTranslate", "sessionChat.cancel"], ["class", "btn btn-primary m-2", 3, "disabled", "click", 4, "ngIf"], ["id", "camera-preview", 3, "session", "deviceId", "width", "height"], ["jhiTranslate", "sessionChat.coachSessionControl.selectSpeaker", 1, "item-bold"], [3, "value"], [3, "deviceId"], [1, "mt-2"], ["jhiTranslate", "sessionChat.coachSessionControl.transcriptionLanguage", 1, "item-bold", "d-inline-block"], ["matTooltipClass", "transcription-tooltip", 1, "ml-1", "transcription-info-icon", 3, "matTooltipPosition", "matTooltip"], ["icon", "info-circle"], ["tabindex", "-1", 3, "ngModel", "ngModelChange", "selectionChange"], [3, "emoji"], [1, "btn", "btn-primary", "m-2", 3, "disabled", "click"], ["jhiTranslate", "inukaNgApp.coachNavbarNotification.joinSession"], [1, "d-flex", "flex-column", "p-0", "h-100", "bg-white"], ["class", "mb-4", 3, "isCameraOn", "session", "deviceId", 4, "ngIf"], ["jhiTranslate", "sessionChat.coachSessionControl.microphone", 1, "item-bold", "mb-0", "ml-4"], ["class", "mb-4", 3, "deviceId", 4, "ngIf"], ["class", "mt-3 px-4", 4, "ngIf"], [1, "d-flex", "justify-content-center", "align-items-end", "m-2", "my-4", "flex-grow-1"], [1, "mb-4", 3, "isCameraOn", "session", "deviceId"], [1, "mb-4", 3, "deviceId"], [1, "mt-3", "px-4"], ["appearance", "outline", 1, "mb-4"]], template: function JoinVideoCallComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, JoinVideoCallComponent_div_0_Template, 25, 12, "div", 0);
        i0.ɵɵtemplate(1, JoinVideoCallComponent_div_1_Template, 13, 5, "div", 1);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.windowWidth > ctx.screenThreshold);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.windowWidth < ctx.screenThreshold);
    } }, directives: [i8.NgIf, i9.JhiTranslateDirective, i10.MatFormField, i11.MatSelect, i12.NgControlStatus, i12.NgModel, i8.NgForOf, i13.CameraPreviewComponent, i14.MatOption, i15.AudioPreviewComponent, i16.MatTooltip, i17.FaIconComponent, i18.EmojiComponent], pipes: [i19.TranslatePipe, i20.FindFlagCodeFromKeyPipe], styles: [".join-video-call[_ngcontent-%COMP%]{margin-top:80px}.item-bold[_ngcontent-%COMP%]{margin-bottom:15px;font-family:\"Poppins\",serif;font-style:normal;font-weight:700;color:#0a4a3a}.form-card[_ngcontent-%COMP%]{padding:30px 20px 30px 20px;border-radius:10px;height:673px !important}[_nghost-%COMP%]  .mat-form-field-flex, [_nghost-%COMP%]  .mat-form-field{width:100% !important}[_nghost-%COMP%]  .mat-form-field-appearance-outline .mat-form-field-outline{color:#cce9e0 !important}[_nghost-%COMP%]  .modal-content{border-radius:10px !important}[_nghost-%COMP%]  .transcription-info-icon{color:#8a9d98}[_nghost-%COMP%]  .transcription-tooltip{background:#8a9d98;font-size:12px;white-space:pre-line}"] });
